import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa";

const Overview = ({overview}) => {
  return (
    <div className="overview-container">
      <h2 className="overview-title">Overview</h2>

      <div dangerouslySetInnerHTML={{__html: overview}} className="overview-section">
        </div>
    </div>
  );
};

export default Overview;
